
import {formaterOgTitle} from "~/helpers/formaterOgTitle";

export default {
  name: "index",

  // computed: {
  //   cmsPageId: function () {
  //     return Number.parseFloat(this?.$nuxt?.context?.env?.cmsPageIdTipGruza)
  //   }
  // },
  // head: function () {
  //   return this.headPage
  // },
  // data: function () {
  //   return {
  //     headPage: {}
  //   }
  // },
  // fetch: async function () {
  //   const path = this.$route?.path || "";
  //   const slug = path.split("/").pop();
  //   const category = await this.$api.agent.transport.get(`/categories/${slug}`).then((res) => {
  //     return res.data
  //   }).catch(() => {
  //     return null
  //   })
  //   if (!category) {
  //     return
  //   }
  //
  //   const title = category?.seo_title || category?.name;
  //   const description = category?.seo_description;
  //
  //   this.headPage = {
  //     title: title,
  //     meta: [
  //       {name: 'og:title', hid: 'og:title', property: 'og:title', content: formaterOgTitle(title, this.$store.state.appState.config)},
  //
  //       {hid: 'metadescription', name: 'description', content: description},
  //       {hid: 'og:description', name: 'og:description', property: 'og:description', content: description}
  //     ],
  //   }
  // }
}
